import { AppProps } from '../../../@types/AppProps';
import { Condition } from '../../../@types/Condition';
import { Lead } from '../../../@types/Lead';
import { Pair } from '../../../@types/Pair';
import { Valuation } from '../../../@types/Valuation';
import { ValuationState } from '../../../@types/ValuationState';

const objToKeyValue = (obj: { [key: string]: string }): Pair[] =>
  Object.keys(obj).map((key) => ({
    key,
    value: obj[key],
  }));

export const createLeadBody = (
  valuationState: ValuationState,
  valuation: Valuation,
  settings: AppProps
): Lead => ({
  firstName: valuationState.fname,
  lastName: valuationState.lname,
  type: 'registrationOfInterestToSell',
  phoneNumber: valuationState.phone,
  branchId: valuationState.branchId,
  email: valuationState.email,
  metaData: objToKeyValue({
    condition: valuationState.condition as Condition,
    registrationNumber: valuationState.registrationNumber,
    description: valuationState.description,
    milage: valuationState.mileage,
    pricePrediction: `${valuation.price.prediction}`,
    conditionReductionVeryGood: `${settings.conditionReduction.veryGood}`,
    conditionReductionGood: `${settings.conditionReduction.good}`,
    conditionReductionOk: `${settings.conditionReduction.ok}`,
  }),
});
